"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react2 = require("@headlessui/react");
var _Icon = require("../Icon");
var _Text = require("../Text");
var _Theme = require("../Theme");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Toast = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    className,
    open = true,
    showIcon = true,
    variant = "info",
    maxWidth = "max-w-2xl",
    position = "topCenter",
    delay = 5000,
    onClose,
    hideClose,
    title,
    ...props
  } = _ref;
  const {
    theme: {
      toast: toastTheme
    }
  } = (0, _Theme.useThemeConfig)();
  (0, _react.useEffect)(() => {
    if (open && delay) {
      const timer = setTimeout(onClose, delay);
      return () => clearTimeout(timer);
    }
  }, [open, delay]);
  const icon = variant === "error" ? /*#__PURE__*/_react.default.createElement(_Icon.AlertCircle, {
    className: toastTheme.error.iconColor,
    "aria-hidden": "true"
  }) : variant === "success" ? /*#__PURE__*/_react.default.createElement(_Icon.CheckCircle2, {
    className: toastTheme.success.iconColor,
    "aria-hidden": "true"
  }) : variant === "warning" ? /*#__PURE__*/_react.default.createElement(_Icon.AlertTriangle, {
    className: toastTheme.warning.iconColor,
    "aria-hidden": "true"
  }) : /*#__PURE__*/_react.default.createElement(_Icon.Info, {
    className: toastTheme.info.iconColor,
    "aria-hidden": "true"
  });
  return /*#__PURE__*/_react.default.createElement(_react2.Transition.Root, {
    show: open,
    as: _react.Fragment
  }, /*#__PURE__*/_react.default.createElement(_react2.Transition.Child, {
    as: _react.Fragment,
    enter: toastTheme.animation.enter,
    enterFrom: toastTheme.animation.enterFrom,
    enterTo: toastTheme.animation.enterTo,
    leave: toastTheme.animation.leave,
    leaveFrom: toastTheme.animation.leaveFrom,
    leaveTo: toastTheme.animation.leaveTo
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "presentation",
    className: (0, _classnames.default)(toastTheme.container, toastTheme[position]),
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    role: "alert",
    className: (0, _classnames.default)(toastTheme.base, toastTheme[variant].bgColor, toastTheme[variant].border, maxWidth, className)
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: toastTheme.box
  }, showIcon ? icon : null, /*#__PURE__*/_react.default.createElement("div", {
    className: toastTheme.textContainer
  }, typeof title === "string" ? /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "body-md",
    className: toastTheme.title
  }, title) : title, typeof children === "string" ? /*#__PURE__*/_react.default.createElement(_Text.Text, null, children) : children), !hideClose && /*#__PURE__*/_react.default.createElement(_Icon.X, {
    className: toastTheme.close,
    size: toastTheme.closeSize,
    "aria-label": "Close",
    onClick: onClose
  }))))));
});
exports.Toast = Toast;
Toast.displayName = "Toast";